import React from 'react'
import { Box } from 'components/layout/Box/Box'
import { useCompetencyState } from './hooks'
import { t } from 'ttag'
import tabStyles from '../tabs.module.scss'
import styles from './Competency.module.scss'
import { RadarChart } from 'components/common/RadarChart/RadarChart'
import { TraitsMatch } from 'components/common/TraitsMatch/TraitsMatch'
import { CompetencyCards } from './CompetencyCards'
import cx from 'classnames'
import { BarChart } from 'components/common/BarChart/BarChart'
import { CandidateSelect } from '../../common/CandidateSelect/CandidateSelect'

export const Competency = ({
  response,
  project,
  language,
  selectedCompetency,
  setSelectedCompetency,
  setSelectedCandidates,
  selectedCandidates,
  candidates,
}) => {
  const single = candidates.length === 1

  const { state, handlers } = useCompetencyState({
    project,
    language,
    response,
    selectedCompetency,
  })

  const {
    visibleCategories,
    showRadar,
    traitScores,
    explanations,
    radarData,
  } = state
  const { getTraitScores, getScoreLabel } = handlers
  const selectedExplanation = explanations[selectedCompetency]

  return (
    <Box className={styles.competency}>
      <div
        className={cx(styles.leftSection, {
          [styles.withRadar]: showRadar,
        })}
      >
        <div className={tabStyles.tabTitle}>{t`Profile match`}</div>
        <div
          className={tabStyles.sectionExplanations}
        >{t`Estimated match for each competency`}</div>

        {showRadar ? (
          <div className={styles.radarChart}>
            <RadarChart
              data={radarData}
              single={single}
              selectedCandidates={selectedCandidates}
              candidates={candidates}
              maxHeight={'20rem'}
              selected={selectedCompetency}
              setSelected={setSelectedCompetency}
            />
          </div>
        ) : single ? (
          <CompetencyCards
            data={visibleCategories[0].scores}
            traitScores={traitScores}
            getTraitScores={getTraitScores}
            explanations={explanations}
            getScoreLabel={getScoreLabel}
            scores={response[0].scores}
            language={language}
          />
        ) : (
          <BarChart
            data={radarData}
            candidates={candidates}
            selectedCandidates={selectedCandidates}
            selected={selectedCompetency}
            setSelected={setSelectedCompetency}
          />
        )}
      </div>
      {showRadar || !single ? (
        <div
          className={cx(styles.rightSection, {
            [styles.withRadar]: showRadar,
          })}
        >
          {single ? (
            <div className={styles.rightSectionHeader}>
              <div className={styles.rightSectionTitle}>
                {visibleCategories[0].scores[selectedCompetency].label}
              </div>
              <div className={styles.score}>
                {`Match: ${getScoreLabel(
                  visibleCategories[0].scores,
                  selectedCompetency,
                )}`}
              </div>
            </div>
          ) : (
            <div className={styles.rightSectionDoubleHeader}>
              <div className={styles.rightSectionTitle}>
                {visibleCategories[0].scores[selectedCompetency].label}
              </div>
              <div className={styles.select}>
                <CandidateSelect
                  {...{
                    candidates,
                    selectedCandidates,
                    setSelectedCandidates,
                    selectedCandidates,
                  }}
                />
                <div className={styles.pills}>
                  {visibleCategories?.map(cat => {
                    const candidateClass = candidates.findIndex(
                      cand => cand.id === cat.id,
                    )
                      ? styles.second
                      : styles.first

                    return (
                      <div
                        className={cx(styles.pill, candidateClass, {
                          [styles.hide]: !selectedCandidates[cat.id],
                        })}
                        key={cat.id}
                      >
                        <div className={styles.pillLabel}>{`${getScoreLabel(
                          cat.scores,
                          selectedCompetency,
                        )} match`}</div>
                        <div className={styles.pillSteps}>
                          {[1, 2, 4].map((boundary, index) => {
                            const isActive =
                              boundary <=
                              cat.scores[selectedCompetency]['score']

                            return (
                              <div
                                key={index}
                                className={cx(
                                  styles.pillStep,
                                  styles['pillStep' + index],
                                  {
                                    [styles.active]: isActive,
                                  },
                                )}
                              ></div>
                            )
                          })}
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          )}

          <div className={styles.paragraph}>
            <div>{selectedExplanation[0]}</div>
            <br />
            <div>{selectedExplanation[1]}</div>
          </div>
          <TraitsMatch
            data={traitScores}
            single={single}
            language={language}
            candidates={candidates}
            selectedCandidates={selectedCandidates}
          />
        </div>
      ) : null}
    </Box>
  )
}
